<template>
  <div class="w-full">
    
    <div class="relative h-6 mb-6 w-full select-none">
      
      <div class="absolute top-1/2 left-0 right-0 -translate-y-1/2 h-2 bg-gray-200 rounded-full z-0 mr-[16px]">
        <div class="absolute h-full bg-primary rounded-full" style="margin-left:8px;margin-right:-8px;" :style="trackStyle"></div>
        
        <!-- Bola mínima -->
        <div class="absolute top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-2 border-primary rounded-full shadow pointer-events-none"
             :style="{ left: percentMin + '%' }"></div>

        <!-- Bola máxima -->
        <div class="absolute top-1/2 -translate-y-1/2 w-4 h-4 bg-white border-2 border-primary rounded-full shadow pointer-events-none"
             :style="{ left: percentMax + '%' }"></div>
      </div>
        <input
          type="range"
          :min="safeMin"
          :max="safeMax"
          :value="safeCurrentMin"
          @input="onDragMin"
          @change="onChangeMin"
          class="absolute w-full h-full opacity-0 z-20 cursor-pointer pointer-events-none slider-ghost"
          />
        <input
          type="range"
          :min="safeMin"
          :max="safeMax"
          :value="safeCurrentMax"
          @input="onDragMax"
          @change="onChangeMax"
          class="absolute w-full h-full opacity-0 z-20 cursor-pointer pointer-events-none slider-ghost"
          />
    </div>

    <div class="flex items-center gap-3">
      <div class="relative w-full">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary text-xs font-bold text-gray-500">Min</span>
        <input
          type="number"
          :value="displayMin"
          @input="onInputMin"
          class="w-full pl-10 pr-2 py-1.5 text-sm border border-border rounded bg-surface focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
        />
      </div>

      <span class="text-text-secondary font-medium">-</span>

      <div class="relative w-full">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary text-xs font-bold text-gray-500">Max</span>
        <input
          type="text"
          :value="displayMax"
          @input="onInputMax"
          class="w-full pl-10 pr-2 py-1.5 text-sm border border-border rounded bg-surface focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceRange',
  props: {
    min: { type: [Number, String], default: 0 },      // <--- Afegit String
    max: { type: [Number, String], default: 1000 },   // <--- Afegit String
    values: { type: Array, default: () => [] }, // <--- AÑADIR ESTA LÍNEA

    // El v-model de un componente en Vue 3 es `modelValue` + `update:modelValue`
    // (en Vue 2 era `value` + `input`). Son indices de `values`, no precios.
    modelValue: {
      type: Array,
      required: true,
      default: () => [0, 1000] // Valor por defecto para evitar el error de undefined
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      tempMin: null,
      tempMax: null,
      isDragging: false
    };
  },
    computed: {
    safeMin() { return parseInt(this.min) || 0; },
    safeMax() { 
      const m = parseInt(this.max);
      return m > 0 ? m : 99999; 
    },
    
    // Estos devuelven ÍNDICES para los sliders
    safeCurrentMin() { 
      if (this.isDragging && this.tempMin !== null) {
        return this.tempMin;
      }
      return this.modelValue && this.modelValue[0] !== undefined ? parseInt(this.modelValue[0]) : 0; 
    },
    safeCurrentMax() { 
      if (this.isDragging && this.tempMax !== null) {
        return this.tempMax;
      }
      return this.modelValue && this.modelValue[1] !== undefined ? parseInt(this.modelValue[1]) : this.safeMax; 
    },
    
    // Estos convierten índices a PRECIOS para mostrar en los inputs
    displayMin() {
      return this.values[this.safeCurrentMin] || 0;
    },
    displayMax() {
      const price = this.values[this.safeCurrentMax] || 0;
      return this.safeCurrentMax === this.safeMax ? `+${price}` : price;
    },
    
    currentMin() { return this.modelValue && this.modelValue[0] ? this.modelValue[0] : 0; },
    currentMax() { return this.modelValue && this.modelValue[1] ? this.modelValue[1] : 0; },
    
    percentMin() {
      return ((this.safeCurrentMin - this.safeMin) / (this.safeMax - this.safeMin)) * 100;
    },
    percentMax() {
      return ((this.safeCurrentMax - this.safeMin) / (this.safeMax - this.safeMin)) * 100;
    },
    trackStyle() {
      return {
        left: `${this.percentMin}%`,
        right: `${100 - this.percentMax}%`
      };
    }
  },
  methods: {
    onDragMin(e) {
      const inputValue = parseInt(e.target.value) || 0;
      this.isDragging = true;
      this.tempMin = inputValue;
    },
    onDragMax(e) {
      const inputValue = parseInt(e.target.value) || 0;
      this.isDragging = true;
      this.tempMax = inputValue;
    },
    onChangeMin(e) {
      const inputValue = parseInt(e.target.value) || 0;
      this.isDragging = false;
      this.tempMin = null;
      this.tempMax = null;
      
      if (inputValue > this.currentMax) {
        this.$emit('update:modelValue', [this.currentMax, this.currentMax]);
      } else {
        this.$emit('update:modelValue', [inputValue, this.currentMax]);
      }
    },
    onChangeMax(e) {
      const inputValue = parseInt(e.target.value) || 0;
      this.isDragging = false;
      this.tempMin = null;
      this.tempMax = null;
      
      if (inputValue < this.currentMin) {
        this.$emit('update:modelValue', [this.currentMin, this.currentMin]);
      } else {
        this.$emit('update:modelValue', [this.currentMin, inputValue]);
      }
    },
    
    onInputMin(e) {
      const inputValue = parseInt(e.target.value) || 0;

      if (e.target.type === 'range') {
        if (inputValue > this.currentMax) {
          this.$emit('update:modelValue', [this.currentMax, this.currentMax]);
        } else {
          this.$emit('update:modelValue', [inputValue, this.currentMax]);
        }
        return;
      }

      const priceValue = inputValue;
      let closestIndex = 0;
      let minDiff = Math.abs(this.values[0] - priceValue);

      for (let i = 1; i < this.values.length; i++) {
        const diff = Math.abs(this.values[i] - priceValue);
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = i;
        }
      }

      if (closestIndex > this.currentMax) {
        this.$emit('update:modelValue', [this.currentMax, this.currentMax]);
      } else {
        this.$emit('update:modelValue', [closestIndex, this.currentMax]);
      }
    },
    onInputMax(e) {
      let inputValue = e.target.value;
    
      inputValue = inputValue.replace('+', '');
      inputValue = parseInt(inputValue) || 0;

      if (e.target.type === 'range') {
        if (inputValue < this.currentMin) {
          this.$emit('update:modelValue', [this.currentMin, this.currentMin]);
        } else {
          this.$emit('update:modelValue', [this.currentMin, inputValue]);
        }
        return;
      }

      const priceValue = inputValue;
      let closestIndex = 0;
      let minDiff = Math.abs(this.values[0] - priceValue);

      for (let i = 1; i < this.values.length; i++) {
        const diff = Math.abs(this.values[i] - priceValue);
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = i;
        }
      }

      if (closestIndex < this.currentMin) {
        this.$emit('update:modelValue', [this.currentMin, this.currentMin]);
      } else {
        this.$emit('update:modelValue', [this.currentMin, closestIndex]);
      }
    }
  }
};
</script>

<style scoped>
.slider-ghost::-webkit-slider-thumb {
  pointer-events: auto;
  -webkit-appearance: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
}
.slider-ghost::-moz-range-thumb {
  pointer-events: auto;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
}
</style>